import CheckCircle from '@mui/icons-material/CheckCircle';
import CloudOff from '@mui/icons-material/CloudOff';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import Sync from '@mui/icons-material/Sync';
import { type SxProps, type Theme } from '@mui/material/styles';

export type ResultIconProps = {
  variant?: 'success' | 'warning' | 'success-warning' | 'offline' | 'uploading';
  size?: 'large' | 'medium' | 'small';
  sx?: SxProps<Theme>;
};

export const ResultIcon = ({ variant = 'success', size = 'large', sx }: ResultIconProps) => {
  switch (variant) {
    case 'success':
      return (
        <CheckCircle
          fontSize={size}
          data-testid="accepted-icon"
          sx={{
            color: (theme) => theme.palette.success[200],
            ...(sx || {}),
          }}
        />
      );
    case 'warning':
      return (
        <ErrorOutlineOutlined
          fontSize={size}
          data-testid="rejected-icon"
          sx={{
            color: (theme) => theme.palette.error[200],
            ...(sx || {}),
          }}
        />
      );
    case 'success-warning':
      return (
        <CheckCircle
          fontSize={size}
          data-testid="success-warning-icon"
          sx={{
            color: (theme) => theme.palette.success[200],
            ...(sx || {}),
          }}
        />
      );
    case 'offline':
      return (
        <CloudOff
          fontSize={size}
          data-testid="offline-icon"
          sx={{
            color: (theme) => theme.palette.text.secondary,
            ...(sx || {}),
          }}
        />
      );
    case 'uploading':
      return (
        <Sync
          fontSize={size}
          data-testid="uploading-icon"
          sx={{
            '@keyframes spin': {
              '0%': {
                transform: 'translate(50%, -50%) rotate(0deg)',
              },
              '100%': {
                transform: 'translate(50%, -50%) rotate(360deg)',
              },
            },
            animation: 'spin 2s linear infinite',
            animationDirection: 'reverse',
            color: (theme) => theme.palette.primary.main,
            ...(sx || {}),
          }}
        />
      );
  }
};
